// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4n-0";
export var eligibilityCardNotEligible = "_4n-1";